<div *ngIf="showErrorModal" class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title">Please select a doctor</h2>
    <button
      (click)="showErrorModal = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>
<div *ngIf="showSelection" class="print-history-popup">
  <div class="print-history-popup-body">
    <button
      (click)="showSelection = false;showAlert=false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 1em;
        padding: 20% 0;
      "
    >
    <button
    class="search-btn search-btn--newPatient"
    style="width: 40%"
    (click)="handelAddAppointment()"
    matTooltip="הוספת תור חדש"
    >
    Add New Appointment
  </button>
  <button
    *ngIf="!this.patientsService.currentPatient"
    class="search-btn"
    style="width: 40%"
    matTooltip="חסימת זמן"
    (click)="handelBlock()"
  >
    Add Block
  </button>
    </div>
    <div *ngIf="showAlert" class="t-validation-wrap">
      <button class="t-menu-item is-invalid-left"></button>
      <div class="t-validation-message-left" style="width: 20em; top: -5em; font-size: medium;">
        <span style="border-radius: 8px">
          <p style="margin-bottom: 1em;">
            The appointment is not during Activity Hours,<br>
           do you still want to continue creating this appointment?
          </p>
          <div style="display: flex; justify-content: space-between; margin-left: 1vw; margin-right: 1vw;">
            <button class="t-menu-item"  (click)="addAppointment();showAlert=false">
              Yes
            </button>
            <button class="t-menu-item" (click)="showSelection = false;showAlert=false">
              No
            </button>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>
<aside class="l-sidebar l-flex l-column">
  <img
    class="off-mobile sidebar-logo"
    src="../../assets/icons/logo.svg"
    alt="Artisan Sonics"
  />
  <div class="userPanel"></div>
  <app-bar (pageChange)="setPage($event, true)"></app-bar>
   <nav class="mainNav l-fg1 scroller" style="align-content: end;  ">
     <app-legend
    *ngIf="showCalendar && page == 'Calendar'"
    [legendData]="examsLegend"
  ></app-legend> 
  </nav> 
  <app-docpanel></app-docpanel>
</aside>
<!-- ========================== header (start) ========================== -->
<header class="l-header">
  <div class="on-mobile header-logo">
    <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
  </div>
  <div
    class="l-header-panel"
    style="display: flex; flex-direction: row; justify-content: space-between"
  >
    <div *ngIf="ls.clinicUsers && !showPat && !showPatDetails && !showAppointment" style="right: 10em">
      <div class="l-flex l-flex-c t-field t-field-pad">
        <label matTooltip="שם הרופא">
          <img src="../../assets/icons/drb.svg" />
        </label>

        <i class="t-sep"></i>

        <span class="t-validation-wrap l-fg1">
          <select
            [(ngModel)]="ls.doctor"
            class="t-select w100"
            (ngModelChange)="refetchEvents(this.startDateDisplayWithGap,this.endDateDisplayWithGap);refetchActivityHours();handleViewChange()"
            style="text-align: center"
          >
            <option [ngValue]="null">All</option>
            <ng-container *ngFor="let e of getDoctors()">
              <option [value]="e.UID">{{ e.Name }}</option>
            </ng-container>
          </select>
        </span>
      </div>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        width:fit-content;
        justify-content: space-between;
      "
    >
      <img
        style="cursor: pointer; margin:0 5% 0 0"
        matTooltip="settings"
        height="41em"
        width="41em"
        src="../../assets/icons/gear-white.svg"
        (click)="goToSettings()"
      />
      <img
        *ngIf="showCalendar && page == 'Calendar'"
        style="cursor: pointer;  margin:0 5% 0 0"
        matTooltip="select day"
        (click)="picker.open()"
        height="41em"
        width="41em"
        src="../../assets/icons/calendar-white.svg"
      />
      <img
      style="cursor: pointer; margin:0 5% 0 0"
      matTooltip="print day appointments"
      height="41em"
      width="41em"
      *ngIf="showPrintIcon"
      src="../../assets/icons/print.svg"
      (click)="print()"
      />

      <input
        class="t-field t-field--date menstural-field invisible-input"
        matInput
        [matDatepicker]="picker"
        #input
        (dateChange)="goToDate($event.value)"
      />
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>
</header>

<!-- ========================== header (end) ========================== -->
<div
  style="
    margin: 8% 2em 9em 15.2em;
    box-shadow: 2px 2px 20px 0px rgba(24, 24, 25, 0.1);
  "
>
  <h2
    *ngIf="patientsService.currentPatient && showCalendar && page == 'Calendar'"
  >
    schedule appointment for {{ patientsService.currentPatient.First }}
    {{ patientsService.currentPatient.Last }}
  </h2>
  <full-calendar
    *ngIf="showCalendar && page == 'Calendar'"
    #fullcalendar
    [options]="calendarOptions"
  ></full-calendar>
</div>
<app-appointment
  *ngIf="showAppointment"
  [event]="this.selectedEventInfo"
  (closed)="handleCloseAppointmentModal($event)"
></app-appointment>
<app-patients
  *ngIf="showSelectPatient"
  (closed)="handleClosePatientSearchModal($event)"
  [page]="page"
></app-patients>
<app-patdetails
  *ngIf="showPatDetails"
  (closed)="handleClosePatDetailsModal($event)"
  [page]="page"
></app-patdetails>
<app-block
  *ngIf="showBlock"
  [event]="this.selectedEventInfo"
  (closed)="handleCloseBlockModal()"
></app-block>
<app-patient-info
  *ngIf="showPat"
  (pageChange)="setPage($event, false)"
></app-patient-info>
<div *ngIf="eventHover" [style.top]="tooltipPosition.y" [style.left]="tooltipPosition.x" [innerHTML]="tooltipText" class="custom-tooltip"></div>
<app-commerror></app-commerror>
<app-bottombar></app-bottombar>
